const visibleTypes = {
    WORD_GROUP: "WORD_GROUP",
    PARAGRAPH: "PARAGRAPH",
}

export default visibleTypes